import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loader from "../../../loader/Loader";
import ConfirmModal from "../../../modals/ConfirmModal";
import IconsGen from "../../../icons_generator/IconsGen";
import { notifySuccess, notifyError } from "../../../toastify/toastify";
import AxiosController from "../../../authentication/AxiosController";
import dateFormat from "dateformat";

const LightFunnelsTokenTable = () => {
  const { slug, lang } = useParams();
  const token = localStorage.getItem("token");
  const [t] = useTranslation("global");

  const [apiKeys, setApiKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedKeyId, setSelectedKeyId] = useState(null);

  const getApiKeys = () => {
    setLoading(true);
    AxiosController.get(`/api/${slug}/${lang}/get-secrets?type=lightfunnels`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        setApiKeys(Array.isArray(res.data) ? res.data : [res.data].filter(Boolean));
      })
      .catch(() => { setLoading(false); })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = () => {
    if (!selectedKeyId) return;
    setLoading(true);

    AxiosController.delete(`api/${slug}/${lang}/remove-secret/${selectedKeyId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(() => {
        notifySuccess(t("panel.delete_successful"));
        getApiKeys();
      })
      .catch((e) => {
        notifyError(e.message || "Failed to delete API key");
      })
      .finally(() => {
        setLoading(false);
        setShowConfirmModal(false);
        setSelectedKeyId(null);
      });
  };

  const handleShowDeleteModal = (id) => {
    setSelectedKeyId(id);
    setShowConfirmModal(true);
  };

  useEffect(() => {
    getApiKeys();
  }, [slug, lang]);

  return (
    <div className="position-relative tables-container" style={{ minHeight: "100px", width: "100%" }}>
      <Loader active={loading} />

      <ConfirmModal
        showModal={showConfirmModal}
        setShowModal={setShowConfirmModal}
        action={handleDelete}
        modalBody="deleteSure"
        modalHeader="deleteProduct"
        confirmButton="confirm"
      />

      <div className="tables-container d-flex flex-column px-2" style={{ position: "relative", flexGrow: 3 }}>
        <div className="footer d-flex flex-column flex-grow-1">
          <div className="mt-4">
            <h4>{t("panel.apiKeys")}</h4>

            <div className="table-responsive">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    <th>{t("panel.date")}</th>
                    <th>{t("panel.code")}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {apiKeys.length > 0 ? (
                    apiKeys.map((key) => (
                      <tr key={key.id}>
                        <td>{dateFormat(key["created_at"], "dd/mm/yyyy h:MM TT")}</td>
                        <td>{key.secretKey.slice(0, 60)}...</td>
                        <td
                          className="align-middle px-3"
                          onClick={() => handleShowDeleteModal(key.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <IconsGen icon_name="delete" />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        {t("panel.noApiKeys")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LightFunnelsTokenTable;
